<template>
  <div class="modifica-struttura" v-if="!isFetching">
    <h3 v-if="struttura_nuova">{{ labels.crea_nuova_struttura }}</h3>
    <h3 v-else>{{ labels.modifica_struttura }}</h3>
    <br />
    <b-form-row class="b-form-row">
      <b-col sm="12" md="4" lg="4" xl="4">
        <b-form-group v-bind:label="labels.codice">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="codice"
            v-model="struttura.codice"
            maxlength="45"
            v-bind:readonly="!struttura_nuova"
          ></b-form-input>
          <p class="errore" id="errore-codice" v-if="isError(errori.codice)">
            {{ labels_errori[errori.codice] }}
          </p>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="8" lg="8" xl="8">
        <b-form-group v-bind:label="labels.descrizione">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="descrizione"
            v-model="struttura.descrizione"
            maxlength="250"
            v-bind:readonly="!struttura_nuova"
          ></b-form-input>
          <p
            class="errore"
            id="errore-descrizione"
            v-if="isError(errori.descrizione)"
          >
            {{ labels_errori[errori.descrizione] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>

    <b-form-row class="b-form-row" v-if="!struttura_nuova">
      <b-col sm="12" md="4" lg="4" xl="4">
        <b-form-group class="b-form-group" v-bind:label="labels.telefono">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="telefono"
            v-model="struttura.telefono"
            maxlength="45"
            type="text"
            readonly="readonly"
          ></b-form-input>
          <p
            class="errore"
            id="errore-telefono"
            v-if="isError(errori.telefono)"
          >
            {{ labels_errori[errori.telefono] }}
          </p>
        </b-form-group>
      </b-col>

      <b-col sm="12" md="6" lg="6" xl="6">
        <b-form-group class="b-form-group" v-bind:label="labels.email">
          <b-form-input
            :size="size"
            class="b-form-input"
            id="email"
            v-model="struttura.email"
            maxlength="255"
            type="text"
            readonly="readonly"
          ></b-form-input>
          <p class="errore" id="errore-email" v-if="isError(errori.email)">
            {{ labels_errori[errori.email] }}
          </p>
        </b-form-group>
      </b-col>

      <b-col sm="12" md="2" lg="2" xl="2">
        <b-form-group class="b-form-group" v-bind:label="labels.disabilitata">
          <b-form-checkbox
            id="disabilitata"
            v-model="struttura.disabilitata"
            name="disabilitata"
            value="S"
            unchecked-value
          ></b-form-checkbox>
          <p
            class="errore"
            id="errore-disabilitata"
            v-if="isError(errori.disabilitata)"
          >
            {{ labels_errori[errori.disabilitata] }}
          </p>
        </b-form-group>
      </b-col>
    </b-form-row>
    <br />

    <div v-if="struttura_nuova">
      <b-form-row class="b-form-row">
        <b-col sm="12" md="6" lg="4" xl="4">
          <b-form-group
            class="b-form-group"
            v-bind:label="labels.utente_amministratore"
          >
            <b-form-input
              :size="size"
              class="b-form-input"
              id="utente-amministratore"
              v-model="utente_amministratore.codice"
              maxlength="45"
              type="text"
            ></b-form-input>
            <p
              class="errore"
              id="errore-utente-amministratore"
              v-if="isError(errori.utente_amministratore)"
            >
              {{ labels_errori[errori.utente_amministratore] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="8" xl="8">
          <b-form-group
            class="b-form-group"
            v-bind:label="labels.email_amministratore"
          >
            <b-form-input
              :size="size"
              class="b-form-input"
              id="email-amministratore"
              v-model="utente_amministratore.email"
              maxlength="255"
              type="text"
            ></b-form-input>

            <p
              class="errore"
              id="errore-email-amministratore"
              v-if="isError(errori.email_amministratore)"
            >
              {{ labels_errori[errori.email_amministratore] }}
            </p>
            <p style="text-align: justify; color: orange; font-weight: 700">
              {{ labels.un_email_verra_inviata }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="12" md="6" lg="6" xl="6">
          <b-form-group
            class="b-form-group"
            v-bind:label="labels.password_amministratore"
          >
            <b-form-input
              :size="size"
              class="b-form-input"
              id="password-amministratore"
              v-model="utente_amministratore.password"
              maxlength="255"
              type="password"
              autocomplete="off"
            ></b-form-input>
            <p
              class="errore"
              id="errore-password-amministratore"
              v-if="isError(errori.password_amministratore)"
            >
              {{ labels_errori[errori.password_amministratore] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col sm="12" md="6" lg="6" xl="6">
          <b-form-group
            class="b-form-group"
            v-bind:label="labels.conferma_password"
          >
            <b-form-input
              :size="size"
              class="b-form-input"
              id="conferma-password"
              v-model="conferma_password"
              maxlength="255"
              type="password"
              autocomplete="off"
            ></b-form-input>
            <p
              class="errore"
              id="errore-conferma-password"
              v-if="isError(errori.conferma_password)"
            >
              {{ labels_errori[errori.conferma_password] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>
    </div>

    <b-form-row class="b-form-row" style="text-align: center">
      <b-col sm="6" md="6" lg="6" xl="6">
        <b-button variant="warning" @click="ritorna" style="width: 100%">{{
          labels.ritorna_alla_lista
        }}</b-button>
        <div class="errore" id="errore-ritorna" v-if="isError(errori.ritorna)">
          <br />
          {{ labels_errori[errori.ritorna] }}
        </div>
      </b-col>
      <b-col sm="6" md="6" lg="6" xl="6">
        <b-button
          variant="success"
          @click="salva"
          :disabled="invio_in_corso"
          style="width: 100%"
          >{{ labels.salva_modifiche }}</b-button
        >
        <div class="errore" id="errore-struttura" v-if="isError(errori.salva)">
          <br />
          {{ labels_errori[errori.salva] }}
        </div>
      </b-col>
    </b-form-row>
    <br />

    <!--
    <b-form-row class="b-form-row" style="text-align:center">
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-alert
          :show="dismissCountDown"
          dismissible
          fade
          variant="warning"
          @dismiss-count-down="countDownChanged"
        >{{ labels.aggiornamento_effettuato }}</b-alert>
      </b-col>
    </b-form-row>
    -->

    <b-row
      style="text-align: center"
      class="errore"
      v-if="isError(errori.generale)"
    >
      <b-col sm="12" md="12" lg="12" xl="12">
        <div id="errore-generale">{{ labels_errori[errori.generale] }}</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import { utility } from "@/utility";
const axios = require("axios");

export default {
  name: "ModificaStruttura",
  data() {
    return {
      struttura_nuova: false,
      labels: {},
      labels_errori: {},
      errori: [],
      // codice_struttura: "",
      struttura: {
        codice: "",
        descrizione: "",
        email: "",
        telefono: "",
        disabilitata: "",
      },
      utente_amministratore: {
        codice: "",
        email: "",
        password: "",
        lingua: "",
      },
      conferma_password: "",
      size: "sm",
      isFetching: true,
      invio_in_corso: false,
    };
  },
  props: {},
  components: {},

  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
    "struttura.codice"(codice_struttura) {
      if (codice_struttura != undefined && codice_struttura != "") {
        this.utente_amministratore.codice = codice_struttura + "_Administrator";
        // this.struttura.codice = codice_struttura;
      } else {
        this.utente_amministratore.codice = "";
      }
    },
  },
  mixins: [utility],

  methods: {
    salva() {
      try {
        let me = this;

        if (!fn_ControllaDati(this)) {
          return;
        }

        this.utente_amministratore.lingua = this.$store.state.Lingua;

        let parametri = {
          utente_collegato: this.$store.state.Utente,
          password_utente_collegato: this.$store.state.Password,
          codice_partner: this.$store.state.Utente,
          dati_struttura: this.struttura,
          dati_amministratore: this.utente_amministratore,
          struttura_nuova: this.struttura_nuova ? "S" : "N",
          url_completa_registrazione:
            this.$store.state.LocalURL + "home/completaregistrazione",
          url_login: this.$store.state.LocalURL,
        };

        let ServerURL = this.$store.state.ServerURL;
        let parametri_json = JSON.stringify(parametri);

        fn_CambiaCursore("wait", this);
        this.invio_in_corso = true;

        axios({
          method: "post",
          url: ServerURL + "CheckIn/SalvaStruttura",
          data: parametri_json,
        })
          .then(function (response) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            if (response.data.errore == 0) {
              me.$root.$children[0].$refs.ApplicationAlert.show(
                me.labels.aggiornamento_effettuato,
                function () {
                  me.$router.push("/menupartner/gestionestrutture");
                }
              );
            } else if (response.data.errore == -2) {
              me.registraErrore(response.data.esito, "ModificaStruttura-salva");
            } else {
              me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                title: me.labels_errori.si_e_verificato_un_errore,
                bodyClass: "errore",
              });
            }
          })
          .catch(function (error) {
            me.invio_in_corso = false;
            fn_CambiaCursore("default", me);
            me.registraErrore(error, "ModificaStruttura-salva");
          });
      } catch (error) {
        this.invio_in_corso = false;
        this.registraErrore(error, "ModificaStruttura-salva");
      }
    },
    ritorna() {
      try {
        this.$router.push("/menupartner/gestionestrutture");
      } catch (error) {
        this.registraErrore(error, "ModificaStruttura-ritorna");
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    try {
      let UtenteAutenticato = store.state.UtenteAutenticato;
      let UtentePartner = store.state.UtentePartner;
      if (
        (to.meta.requiresAuth && !UtenteAutenticato) ||
        (to.meta.is_partner && !UtentePartner)
      ) {
        router.push("/menupartner/permessiinsufficienti", null, function () {});
      } else {
        next();
      }
    } catch (error) {
      router.push({ name: "Errore", params: { errore: error.stack } });
    }
  },
  created() {
    try {
      fn_CambiaLingua(this.$store.state.Lingua, this);
      let me = this;
      let codice_struttura = this.$route.params.struttura;

      this.utente_amministratore.codice = "";
      this.utente_amministratore.email = "";
      this.utente_amministratore.password = "";
      this.utente_amministratore.lingua = "";

      if (codice_struttura == undefined || codice_struttura.trim() == "") {
        this.struttura.codice = "";
        this.struttura.descrizione = "";
        this.struttura.email = "";
        this.struttura.telefono = "";

        this.struttura_nuova = true;
        this.isFetching = false;

        return;
      }

      let ServerURL = this.$store.state.ServerURL;

      let parametri = {
        utente_collegato: this.$store.state.Utente,
        password_utente_collegato: this.$store.state.Password,
        struttura: codice_struttura,
      };

      let parametri_json = JSON.stringify(parametri);

      fn_CambiaCursore("wait", this);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/LeggiStruttura",
        data: parametri_json,
      })
        .then(function (response) {
          fn_CambiaCursore("default", me);
          me.struttura = response.data.oggetto.dati_struttura;
          // if (response.data.oggetto.dati_strutture_origine.length > 0) {
          //   me.struttura.codice_origine_simplebooking =
          //     response.data.oggetto.dati_strutture_origine[0].codice_struttura_origine;
          // } else {
          //   me.struttura.codice_simplebooking = "";
          // }
          me.isFetching = false;
        })
        .catch(function (error) {
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "ModificaStruttura-created");
        });
    } catch (error) {
      this.registraErrore(error, "ModificaStruttura-created");
    }
  },
};

function fn_CambiaLingua(lingua, vm) {
  try {
    let labels_italiano = {
      modifica_struttura: "Modifica struttura",
      crea_nuova_struttura: "Crea nuova struttura",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      utente_amministratore: "Utente amministratore",
      email_amministratore: "Email amministratore",
      un_email_verra_inviata:
        "A questo indirizzo verrà inviata un'email contenente un link per permettere all'amministratore della struttura di completare la registrazione.",
      password_amministratore: "Password amministratore",
      conferma_password: "Conferma password",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      disabilitata: "Disabilitata",
      codice_origine_simplebooking:
        "Codice struttura presso SIMPLEBOOKING (opzionale)",
    };
    let labels_inglese = {
      modifica_struttura: "Modifica struttura",
      crea_nuova_struttura: "Crea nuova struttura",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      utente_amministratore: "Utente amministratore",
      email_amministratore: "Email amministratore",
      un_email_verra_inviata:
        "A questo indirizzo verrà inviata un'email contenente un link per permettere all'amministratore della struttura di completare la registrazione.",
      password_amministratore: "Password amministratore",
      conferma_password: "Conferma password",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      disabilitata: "Disabilitata",
      codice_origine_simplebooking:
        "Codice struttura presso SIMPLEBOOKING (opzionale)",
    };
    let labels_tedesco = {
      modifica_struttura: "Modifica struttura",
      crea_nuova_struttura: "Crea nuova struttura",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      utente_amministratore: "Utente amministratore",
      email_amministratore: "Email amministratore",
      un_email_verra_inviata:
        "A questo indirizzo verrà inviata un'email contenente un link per permettere all'amministratore della struttura di completare la registrazione.",
      password_amministratore: "Password amministratore",
      conferma_password: "Conferma password",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      disabilitata: "Disabilitata",
      codice_origine_simplebooking:
        "Codice struttura presso SIMPLEBOOKING (opzionale)",
    };
    let labels_francese = {
      modifica_struttura: "Modifica struttura",
      crea_nuova_struttura: "Crea nuova struttura",
      codice: "Codice",
      descrizione: "Descrizione",
      email: "Email",
      telefono: "Telefono",
      utente_amministratore: "Utente amministratore",
      email_amministratore: "Email amministratore",
      un_email_verra_inviata:
        "A questo indirizzo verrà inviata un'email contenente un link per permettere all'amministratore della struttura di completare la registrazione.",
      password_amministratore: "Password amministratore",
      conferma_password: "Conferma password",
      ritorna_alla_lista: "Ritorna alla lista",
      salva_modifiche: "Salva modifiche",
      aggiornamento_effettuato: "Aggiornamento effettuato",
      disabilitata: "Disabilitata",
      codice_origine_simplebooking:
        "Codice struttura presso SIMPLEBOOKING (opzionale)",
    };

    let labels_errori_italiano = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_struttura_non_valido: "Il codice contiene caratteri non validi. Caratteri ammessi: A-Z a-z 0-9 - _",
      struttura_non_trovata: "Struttura non trovata",
      utente_non_trovato: "Utente non trovato",
      struttura_gia_esistente: "Esiste già una struttura con lo stesso codice. Attenzione! Facile Check-in non fa distinzione fra maiuscole e minuscole.",
      utente_amministratore_gia_esistente:
        "Utente amministratore già esistente",
      password_non_coincidenti: "Password non coincidenti",
    };
    let labels_errori_inglese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_struttura_non_valido: "Il codice contiene caratteri non validi. Caratteri ammessi: A-Z a-z 0-9 - _",
      struttura_non_trovata: "Struttura non trovata",
      utente_non_trovato: "Utente non trovato",
      struttura_gia_esistente: "Esiste già una struttura con lo stesso codice",
      utente_amministratore_gia_esistente:
        "Utente amministratore già esistente",
      password_non_coincidenti: "Password non coincidenti",
    };
    let labels_errori_tedesco = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      codice_struttura_non_valido: "Il codice contiene caratteri non validi. Caratteri ammessi: A-Z a-z 0-9 - _",
      struttura_non_trovata: "Struttura non trovata",
      utente_non_trovato: "Utente non trovato",
      struttura_gia_esistente: "Esiste già una struttura con lo stesso codice",
      utente_amministratore_gia_esistente:
        "Utente amministratore già esistente",
      password_non_coincidenti: "Password non coincidenti",
    };
    let labels_errori_francese = {
      si_e_verificato_un_errore: "Si è verificato un errore",
      si_sono_verificati_degli_errori: "Si sono verificati degli errori",
      dato_obbligatorio: "Dato obbligatorio",
      codice_struttura_non_valido: "Il codice contiene caratteri non validi. Caratteri ammessi: A-Z a-z 0-9 - _",
      indirizzo_email_non_valido: "Indirizzo email non valido",
      struttura_non_trovata: "Struttura non trovata",
      utente_non_trovato: "Utente non trovato",
      struttura_gia_esistente: "Esiste già una struttura con lo stesso codice",
      utente_amministratore_gia_esistente:
        "Utente amministratore già esistente",
      password_non_coincidenti: "Password non coincidenti",
    };

    switch (lingua) {
      case "IT":
        vm.labels = labels_italiano;
        vm.labels_errori = labels_errori_italiano;
        break;
      case "EN":
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
      case "DE":
        vm.labels = labels_tedesco;
        vm.labels_errori = labels_errori_tedesco;
        break;
      case "FR":
        vm.labels = labels_francese;
        vm.labels_errori = labels_errori_francese;
        break;
      default:
        vm.labels = labels_inglese;
        vm.labels_errori = labels_errori_inglese;
        break;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaStruttura-fn_CambiaLingua");
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;

    vm.errori = {};

    if (vm.struttura.codice.trim() == "") {
      vm.errori.codice = "dato_obbligatorio";
      esito = false;
    }
    else{
      let pattern = vm.$store.state.PatternCodiceStruttura;
        if (!pattern.test(vm.struttura.codice)) {
          vm.errori.codice = "codice_struttura_non_valido";
          esito = false;
        }
    }
    if (vm.struttura.descrizione.trim() == "") {
      vm.errori.descrizione = "dato_obbligatorio";
      esito = false;
    }

    // if (vm.struttura.email.trim() == "") {
    //   vm.errori.email = "dato_obbligatorio";
    //   esito = false;
    // } else {
    //   let pattern = vm.$store.state.PatternEmail;
    //   if (!pattern.test(vm.struttura.email)) {
    //     vm.errori.email = "indirizzo_email_non_valido";
    //     esito = false;
    //   }
    // }

    if (vm.struttura_nuova) {
      if (vm.utente_amministratore.codice.trim() == "") {
        vm.errori.utente_amministratore = "dato_obbligatorio";
        esito = false;
      }
      if (vm.utente_amministratore.email.trim() == "") {
        vm.errori.email_amministratore = "dato_obbligatorio";
        esito = false;
      } else {
        let pattern = vm.$store.state.PatternEmail;
        if (!pattern.test(vm.utente_amministratore.email)) {
          vm.errori.email_amministratore = "indirizzo_email_non_valido";
          esito = false;
        }
      }

      if (vm.utente_amministratore.password.trim() == "") {
        vm.errori.password_amministratore = "dato_obbligatorio";
        esito = false;
      } else {
        if (vm.utente_amministratore.password.trim() != vm.conferma_password) {
          vm.errori.password_amministratore = "password_non_coincidenti";
          esito = false;
        }
      }
    }

    if (esito) {
      return true;
    } else {
      vm.errori.generale = "si_sono_verificati_degli_errori";
      return false;
    }
  } catch (error) {
    vm.registraErrore(error, "ModificaStruttura-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}
</script>

<style scoped>
.modifica-struttura {
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
  border-radius: 4px;
  padding: 20px;
}
</style>
